var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2043 2.41502C5.91669 3.21327 2.61561 6.8174 2.27842 11.25H6.78365C7.00451 8.04894 8.1979 4.98601 10.2043 2.41502ZM13.7957 2.41502C15.8021 4.98601 16.9955 8.04894 17.2164 11.25H21.7216C21.3844 6.8174 18.0833 3.21327 13.7957 2.41502ZM15.7124 11.25C15.4707 8.08364 14.1761 5.05886 12 2.60037C9.82392 5.05886 8.52926 8.08364 8.2876 11.25H15.7124ZM8.2876 12.75H15.7124C15.4707 15.9164 14.1761 18.9411 12 21.3996C9.82393 18.9411 8.52927 15.9164 8.2876 12.75ZM6.78365 12.75H2.27842C2.61561 17.1826 5.91671 20.7867 10.2043 21.585C8.19792 19.014 7.00451 15.9511 6.78365 12.75ZM13.7957 21.585C15.8021 19.014 16.9955 15.9511 17.2164 12.75H21.7216C21.3844 17.1826 18.0833 20.7867 13.7957 21.585ZM12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.4dcc707f6d82e11766ff5a70b3329553.svg";
export { ForwardRef as ReactComponent };